import { render, staticRenderFns } from "./channel-banner.vue?vue&type=template&id=42fdd338&scoped=true&"
import script from "./channel-banner.vue?vue&type=script&lang=js&"
export * from "./channel-banner.vue?vue&type=script&lang=js&"
import style0 from "./channel-banner.vue?vue&type=style&index=0&id=42fdd338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fdd338",
  null
  
)

export default component.exports